import CPageH5 from './index.vue';

export default CPageH5;
